import React, { FC } from "react";
import { ProductMeta, ProjectMeta } from "../../models/types";
import { BadgeOverlay } from "./BadgeOverlay";

interface Props {
    metaData: ProductMeta | ProjectMeta;
}

const StatusBadgesImplementation: FC<Props> = ({ metaData }) => {
    const { review, bugged, testAvailable } = metaData;

    return (
        <>
            {review > 0 && (
                <BadgeOverlay text="In Review" variant="review">
                    {review}
                </BadgeOverlay>
            )}
            {bugged > 0 && (
                <BadgeOverlay text="Bugged" variant="warning">
                    {bugged}
                </BadgeOverlay>
            )}
            {testAvailable > 0 && (
                <BadgeOverlay
                    text="Test(s) Available"
                    variant="test-translucent"
                >
                    {testAvailable}
                </BadgeOverlay>
            )}
        </>
    );
};

export const StatusBadges = React.memo(StatusBadgesImplementation);
